<template>
  <section>
    <ModalVue
      :isPasswordConfirmOpen="isModalOpen"
      :closePasswordConfirm="handleModalState"
      :isModal="true"
      :title="translateText(`${title}`)"
      :headerImg="'delete-red-bg.svg'"
    >
      <div class="my-4">
        <p class="mb-5 text-[#545454] text-sm font-normal leading-6">
          {{ translateText(`${message}`) }}
        </p>

        <div class="flex items-center gap-2">
          <ButtonVue
            @handleClick="handleModalState"
            theme="greyOutline"
            size="medium"
            radius="small"
          >
            <p class="text-base font-medium text-gray-700">
              {{ translateText("groups.cancel") }}
            </p></ButtonVue
          >
          <ButtonVue
            @click="deleteFunc"
            theme="blackSolid"
            size="medium"
            radius="small"
          >
            <ClipLoaderVue v-if="deleteLoading" color="white" :size="12" />
            <p v-else class="text-base font-medium text-white">
              {{ translateText("groups.delete") }}
            </p></ButtonVue
          >
        </div>
      </div>
    </ModalVue>
  </section>
</template>

<script>
import { successToast, translateText } from "@/core/helpers/utility";

export default {
  name: "GeneralDeleteModal",
  props: [
    "isModalOpen",
    "refreshRecords",
    "message",
    "title",
    "handleModalState",
    "confirmDelete",
  ],
  data() {
    return {
      translateText,
      deleteLoading: false,
    };
  },
  methods: {
    async deleteFunc() {
      this.deleteLoading = true;

      try {
        const response = await this.confirmDelete();
        successToast(translateText("groups.successDelete"));
        await this.refreshRecords();
        this.handleModalState();
      } finally {
        this.deleteLoading = false;
      }
    },
  },
};
</script>

<style></style>
